<div class="banner" role="banner">
  <h1>{{ 'earn.page.title' | translate }}</h1>
</div>

<div class="container">
  <fgbcl-earn-points [lgWidth]="'4'"></fgbcl-earn-points>
</div>
